import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssetTransferEntryLinkComponent } from './asset-transfer-entry-link/asset-transfer-entry-link.component';
import { AssetTransferEntryLandingPageComponent } from './asset-transfer-entry-landing-page/asset-transfer-entry-landing-page.component';
import { AssetTransferListComponent } from './asset-transfer-list/asset-transfer-list.component';

const routes: Routes = [
  {
    path: '', component: AssetTransferEntryLinkComponent,
    children: [
      { path: 'assetTransferEntry', component: AssetTransferEntryLandingPageComponent },
      { path: 'assetTransferList', component: AssetTransferListComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssetTransferEntryRoutingModule { }
